import logo from './logo.svg';
import './App.css';
import SignaturePad from './components/SignaturePad';

function App() {
  return (
    <div className="App">
      <SignaturePad />
    </div>
  );
}

export default App;
